<template>
	<section class="container cta">
		<h1 class="heading heading-cta heading-cta-regular">online rezervace</h1>
		<router-link :to="{ name: 'booking' }" class="button button-big button-big-yellow centered">
			{{ $t('pages.booking') }}
		</router-link>
		<div class="icon__divider icon__divider-cta">
			<span class="icon icon__divider-outer">
				<span class="icon icon__divider-inner"></span>
			</span>
		</div>
		<div class="cta-item cta-item-address">
			<div class="address">
				<a class="address__link" :href="address.href">
					<div class="address__line">
						<span class="address__street">{{ address.street }}</span
						><span class="address__divider">,</span>
					</div>
					<div class="address_line">
						<span class="address__zip">{{ address.zip }}</span
						><span class="address__divider"> - </span><span class="address__city-extended">{{ address.city }}</span>
					</div>
				</a>
			</div>
		</div>
		<div v-if="openingHours !== 'closed'" class="cta-item cta-item-hours">
			<p>Dnes otevřeno:</p>
			<p>{{ openingHours }}</p>
		</div>
		<div v-else class="cta-item cta-item-hours">
			<p>Dnes zavřeno</p>
		</div>
		<div class="cta-item cta-item-address">
			<div class="contact__phone">
				<a class="contact__phone-link" :href="phoneHref">{{ phone }}</a>
			</div>
		</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			address: 'app/address',
			phone: 'app/phone',
			phoneHref: 'app/phoneHref',
			openingHours: 'app/openingHours',
		}),
	},
}
</script>
